import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Collapse,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { styled, keyframes } from "@mui/material/styles";
import logo from "../../assets/reeflogo.jpg";
import image1 from "../../assets/newvideobanner.mp4";
import image2 from "../../assets/updatedBannerImage/REEF-49.jpg";
import image3 from "../../assets/bannerimage2.jpeg";
import image4 from "../../assets/updatedBannerImage/IMG_3368.jpg";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

const Root = styled("div")({
  display: "flex",
  height: "100vh",
  fontFamily: "Montserrat, Helvetica, Arial, Lucida, sans-serif",
  overflow: "hidden",
  position: "relative",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    height: "auto",
  },
});

const LeftPanel = styled(Box)(({ theme }) => ({
  width: "250px",
  // backgroundColor: "#344246",
  background: "#4eb5c9",
  color: "white",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(2),
  zIndex: 1,
  "@media (max-width: 768px)": {
    width: "100%",
    padding: theme.spacing(3),
    order: 2,
  },
}));

const leftPanelContents = [
  {
    title: "Towards the Conservation of",
    subtitle: "Lesser-known Wildlife",
    button: "Join Us",
    // path: "/join-us",
  },
  {
    title: "Protecting Endangered Species",
    subtitle: "For Future Generations",
    button: "Join Us",
    // path: "/join-us",
  },
  {
    title: "Restoring Natural Habitats",
    subtitle: "One Step at a Time",
    button: "Join Us",
    // path: "/join-us",
  },
  {
    title: "Community-led Conservation",
    subtitle: "Empowering Locals",
    button: "Join Us",
    // path: "/join-us",
  },
  {
    title: "Technology in Conservation",
    subtitle: "Innovate & Protect",
    button: "Join Us",
    // path: "/join-us",
  },
];

const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const AnimatedLeftContent = styled(Box)({
  textAlign: "center",
  animation: `${fadeIn} 0.6s ease-out`,
});

// const RightPanel = styled(Box)({
//     flex: 1,
//     height: "100vh",
//     overflow: "hidden",
//     position: "relative",
//     zIndex: 1,
//     "@media (max-width: 768px)": {
//         width: "100%",
//         height: "calc(100dvh - 56px)",
//         order: 1,
//     },
// });

const ripples = new Array(3).fill(null);

// Ensures container uses full viewport height
const RightPanel = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  height: "100vh",
  width: "83%",
  backgroundColor: "#000",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    position: "relative",
    width: "100%",
    height: "60vh",
    marginTop: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    height: "60vh",
  },
}));

const ScrollContainer = styled("div")(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  overflowY: "hidden",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
  height: "100%",
  width: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    height: "100%",
    width: "100%",
  },
}));

const ScrollItem = styled("div")({
  flex: "0 0 100%",
  scrollSnapAlign: "start",
  height: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
});

const ScrollImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  // filter: "brightness(65%)",
  display: "block",
  margin: 0,
  padding: 0,
});

const DotsContainer = styled("div")({
  position: "absolute", // position over image
  bottom: 20, // 20px from bottom
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 10,
  zIndex: 10,
  pointerEvents: "auto",
});

const Dot = styled("div")(({ active }) => ({
  width: 12,
  height: 12,
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: active ? "#fff" : "rgba(255,255,255,0.5)",
  transition: "background-color 0.3s ease",
}));

// const DotsContainer = styled(Box)({
//     position: "absolute",
//     bottom: "30px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     display: "flex",
//     gap: "8px",
//     zIndex: 3,
// });

// const Dot = styled("div")(({ active }) => ({
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     backgroundColor: active ? "white" : "rgba(255, 255, 255, 0.4)",
//     transition: "all 0.3s ease",
//     cursor: "pointer",
// }));

const OverlayContent = styled(Box)({
  maxWidth: "500px",
  textAlign: "center",
  padding: "20px",
  position: "relative",
});

const fadeSlideUp = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 0; transform: translateY(0); }
`;

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef(null);
  const theme = useTheme();

  const images = [
    { id: 1, src: image2, alt: "Image 1" },
    { id: 2, src: image3, alt: "Image 2" },
    { id: 3, src: image4, alt: "Image 3" },
    { id: 4, src: image1, alt: "Wildlife" },
  ];

  useEffect(() => {
    const container = scrollRef.current;
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(nextIndex);
      container.scrollTo({
        left: container.clientWidth * nextIndex,
        behavior: "smooth",
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  useEffect(() => {
    const container = scrollRef.current;
    const handleScroll = () => {
      const newIndex = Math.round(container.scrollLeft / container.clientWidth);
      setCurrentIndex(newIndex);
    };
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScrollY = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScrollY);
    return () => window.removeEventListener("scroll", handleScrollY);
  }, []);

  const handleDotClick = (index) => {
    const container = scrollRef.current;
    setCurrentIndex(index);
    container.scrollTo({
      left: container.clientWidth * index,
      behavior: "smooth",
    });
  };

  const Ripple = styled("span")(({ delay = 0, isDesktop }) => ({
    position: "absolute",
    top: 90,
    left: 110,
    borderRadius: "50%",
    width: isDesktop ? "80px" : "60px",
    height: isDesktop ? "80px" : "60px",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    transform: "translate(-50%, -50%)",
    animation: `heroripple 8s ${delay}s linear infinite`,
    zIndex: -1,
    pointerEvents: "none",

    "@keyframes heroripple": {
      "0%": {
        transform: "translate(-50%, -50%) scale(2)", // Start already scaled up
        opacity: 0.4,
      },
      "100%": {
        transform: "translate(-50%, -50%) scale(4)", // Just grow a bit more
        opacity: 0,
      },
    },
  }));

  const RippleWrapper = styled(Box)({
    position: "fixed",
    top: "40px",
    left: "40px",
    zIndex: 15,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const LogoWrapper = styled(Box)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  });

  // const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const navigate = useNavigate();
  const Header = styled(AppBar)(({ scrolled }) => ({
    backgroundColor: scrolled ? "black" : "transparent",
    boxShadow: "none",
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 11,
    transition: "background-color 0.3s ease",
  }));

  return (
    <>
      <Root sx={{ mt: { xs: -2, md: 0 } }}>
        <LeftPanel
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
            px: { md: 2, xs: 0 },
          }}
        >
          <AnimatedLeftContent
            key={currentIndex}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: { xs: "14px", sm: "18px" },
                fontWeight: 500,
                color: "#fff",
                letterSpacing: "2px",
                fontFamily: "Montserrat, sans-serif",
                textTransform: "uppercase",
                mb: { xs: 1.5, sm: 2 },
                mt: { md: 15, xs: 0 },
                wordBreak: "break-word",
              }}
            >
              {leftPanelContents[currentIndex].title}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "16px", sm: "17px" },
                fontWeight: "bold",
                color: "#fff",
                mb: { xs: 2, sm: 3 },
                letterSpacing: "3px",
                wordBreak: "break-word",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              {leftPanelContents[currentIndex].subtitle}
            </Typography>

            <Button
              variant="outlined"
              // onClick={() => navigate('/join-us')}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                borderRadius: "30px",
                color: "#344246", // darker text
                backgroundColor: "#f5f5f5", // light background
                borderColor: "#ccc",
                fontFamily: "Montserrat, sans-serif",
                px: 3,
                py: 1.2,
                fontSize: { xs: "12px", sm: "12px" },
                fontWeight: "bold",
                letterSpacing: "3px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                  borderColor: "#bbb",
                  color: "#222",
                },
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#fff",
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#344246",
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: 14,
                  flexShrink: 0,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                }}
              >
                ➤
              </Box>
              {leftPanelContents[currentIndex].button}
            </Button>
          </AnimatedLeftContent>
        </LeftPanel>

        <RightPanel>
          <ScrollContainer ref={scrollRef}>
            {images.map((img) => (
              <ScrollItem key={img.id}>
                {img.src.endsWith(".mp4") ? (
                  <video
                    src={img.src}
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <ScrollImage src={img.src} alt={img.alt} />
                )}
              </ScrollItem>
            ))}
          </ScrollContainer>

          <DotsContainer>
            {images.map((_, idx) => (
              <Dot
                key={idx}
                active={currentIndex === idx}
                onClick={() => handleDotClick(idx)}
              />
            ))}
          </DotsContainer>
        </RightPanel>
      </Root>
    </>
  );
}

export default App;
